import { render } from "./ButtonContainer.vue?vue&type=template&id=aa18596c&scoped=true"
import script from "./ButtonContainer.vue?vue&type=script&lang=js"
export * from "./ButtonContainer.vue?vue&type=script&lang=js"

import "./ButtonContainer.vue?vue&type=style&index=0&id=aa18596c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa18596c"]])

export default __exports__